// import models
import * as PATH from '@src/configs/paths'
import { IMenuItem } from '@src/types/menu'
import { isFeatureEnabled } from '@src/utils'

export const MainMenu: IMenuItem[] = (() => {
    const menu_items = [
        {
            label: 'Swap',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.SWAP,
            _index: 0,
        },
        {
            label: 'Orders',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.ORDERS,
            _index: 1,
        },
        {
            label: 'Miles',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.POINTS,
            _index: 3,
        },
        {
            label: 'Developers',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.DEVS,
            _index: 4,
            target: '_blank',
        },
        {
            label: 'Docs',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.DOCS,
            _index: 5,
            target: '_blank',
        },
    ]

    if (isFeatureEnabled('ONRAMP') || isFeatureEnabled('OFFRAMP')) {
        menu_items.push({
            label: 'Exchange',
            active: 'active',
            inactive: 'inactive',
            navigation: PATH.EXCHANGE,
            _index: 2,
        })
    }

    return menu_items.sort((a, b) => a._index - b._index)
})()
